import { Component, ViewChild } from '@angular/core';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import moment from 'moment';
import { Subject } from 'rxjs';
import { ApprovalTrackingComponent } from '../../../Component/ApprovalTracking/approval-tracking/approval-tracking.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { ApprovalMatrixService } from '../../../Model/ApprovalMatrix/approval-matrix.service';
import { CommonService } from '../../../Model/Common/common.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';

@Component({
  selector: 'app-compensatory-off-approval',
  standalone: true,
  imports: [CommonModule, FormsModule, NgbDatepickerModule, DataTablesModule, RouterModule, LoaderComponent],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './compensatory-off-approval.component.html',
  styleUrl: './compensatory-off-approval.component.scss'
})
export class CompensatoryOffApprovalComponent {
  isDisabled: boolean = false;
  user = [] as any;
  Filter = {
    ModuleMasterId: 13,
    FromDate: '' as any,
    ToDate: '' as any,
    FromDateObj: null as any,
    ToDateObj: null as any,
    EmpMasterId: 0,
    EmpMappingId: 0,
    SelectType1: 'D',
    SelectType: 'Pending',
    TransactionId: 0,
    EmpType: 'All',
    Remark: null
  }
  Counts = {
    ApprovedCount: 0,
    PendingCount: 0,
    PendingWithSeniorCount: 0,
    RejectedCount: 0,
    ReinitiatedCount: 0,
    TransactionId: 0
  }
  //TotalCount : number =  0;
  MainDatas = [];
  TableDatas = [] as any;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private utility: UtilityService,
    private toast: ToastService,
    private approvalMatrix: ApprovalMatrixService,
    private dateFormat: CustomDateParserFormatter,
    protected common: CommonService,
    private modalService: NgbModal,
    private tooltip: TooltipService,
    private session: SessionService,
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    if (this.user.UserType == 'E') {
      this.Filter.EmpMappingId = this.user.UserId;
    }
    this.SelectDate('RegistrationDate', null, null);
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.Filter.FromDateObj = this.dateFormat.parse(response.Table[0].RegistrationDate);
          this.Filter.FromDateObj.day = 1;
          this.Filter.ToDateObj = this.dateFormat.parse(response.Table[0].RegistrationDate);
          this.Filter.ToDateObj.day = new Date(this.Filter.ToDateObj.year, this.Filter.ToDateObj.month, 0).getDate();
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.ApprovalMatrixRequest();
      },
      error: (error) => {
        this.isDisabled = false;
        this.toast.show({ message: error, type: toastTypeEnum.danger });
        return false;
      },
    });
  }

  FilterValidate(form: any) {
    if (form.valid) {
      this.ApprovalMatrixRequest();
    }
    else {
      form.submitted = true;
    }
  }

  ApprovalMatrixRequest() {
    if (this.common.ToLowerCase(this.Filter.SelectType) == 'pending' || (this.common.ToLowerCase(this.Filter.SelectType) != 'pending' && (moment(this.dateFormat.format(this.Filter.ToDateObj), 'DD MMM YYYY').isSameOrAfter(moment(this.dateFormat.format(this.Filter.FromDateObj), 'DD MMM YYYY'))))) {
      this.MainDatas = [];
      this.TableDatas = [];
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
      this.ApprovalMatrixRequestGet();
      this.ApprovalMatrixRequestGetCount();
    } else {
      this.toast.show({ message: this.tooltip.Message.FromDateToDateMessgae, type: toastTypeEnum.danger });
    }
  }

  ApprovalMatrixRequestGet() {
    this.isDisabled = true;
    if (this.Filter.SelectType == 'Pending') {
      this.Filter.FromDate = null;
      this.Filter.ToDate = null;
    } else {
      this.Filter.FromDate = this.Filter.FromDateObj.year + '-' + this.Filter.FromDateObj.month + '-' + this.Filter.FromDateObj.day;
      this.Filter.ToDate = this.Filter.ToDateObj.year + '-' + this.Filter.ToDateObj.month + '-' + this.Filter.ToDateObj.day;
    }
    this.approvalMatrix.ApprovalMatrixRequestGet(this.Filter).subscribe({
      next: (response) => {
        if (this.Filter.ModuleMasterId == 13) {
          this.MainDatas = response.Table;
          // this.TableDatas = Object.values(this.MainDatas.filter((e: any) => this.common.ToLowerCase(e.EmpType) == this.Filter.EmpType));
          this.TableDatas = this.Filter.EmpType === 'All' ? response.Table : Object.values(this.MainDatas.filter((e: any) => this.common.ToLowerCase(e.EmpType) == this.Filter.EmpType));

          // this.MainDatas = response.Table;
          // this.TableDatas = Object.values(this.MainDatas.filter((e: any) => this.common.ToLowerCase(e.EmpType) == this.Filter.EmpType));
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
          //this.TotalCount = this.TableDatas.length;
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ApprovalMatrixRequestGetCount() {
    this.isDisabled = true;
    this.Filter.FromDate = this.Filter.FromDateObj.year + '-' + this.Filter.FromDateObj.month + '-' + this.Filter.FromDateObj.day;
    this.Filter.ToDate = this.Filter.ToDateObj.year + '-' + this.Filter.ToDateObj.month + '-' + this.Filter.ToDateObj.day;
    this.approvalMatrix.ApprovalMatrixRequestGet({ ModuleMasterId: this.Filter.ModuleMasterId, FromDate: this.Filter.FromDate, ToDate: this.Filter.ToDate, EmpMappingId: this.Filter.EmpMappingId, EmpMasterId: this.Filter.EmpMasterId, SelectType1: 'S', SelectType: '' }).subscribe({
      next: (response) => {
        this.Counts = response.Table[0];
        this.common.MenuCounts.Approval.CompensatoryOff = response.Table[0].PendingCount;
        // this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Link(Text: string) {
    return this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + 'EmployeeLeaveAttachment' + '/' + Text;
  }

  Tracking(Id: number) {
    const modalRef = this.modalService.open(ApprovalTrackingComponent, { size: 'lg' });
    modalRef.componentInstance.Detail.ModuleMasterId = this.Filter.ModuleMasterId;
    modalRef.componentInstance.Detail.EmpMasterId = this.TableDatas.filter((e: any) => e.WebESSApprovalRequestTrackingId == Id)[0]['EmpMasterId'];
    modalRef.componentInstance.Detail.TransactionId = this.TableDatas.filter((e: any) => e.WebESSApprovalRequestTrackingId == Id)[0]['TransactionId'];
    modalRef.componentInstance.Detail.UserImage = this.common.PhotoLink(this.TableDatas.filter((e: any) => e.WebESSApprovalRequestTrackingId == Id)[0]['Photo']);
    modalRef.componentInstance.Detail.EmployeeName = this.TableDatas.filter((e: any) => e.WebESSApprovalRequestTrackingId == Id)[0]['EmployeeName'];
    modalRef.componentInstance.Detail.EmpCode = this.TableDatas.filter((e: any) => e.WebESSApprovalRequestTrackingId == Id)[0]['EmpCode'];
    modalRef.componentInstance.Detail.DesignationName = this.TableDatas.filter((e: any) => e.WebESSApprovalRequestTrackingId == Id)[0]['DesignationName'];

    modalRef.result.then(result => { });
  }

  // FilterEmpType(type: string) {
  //   this.Filter.EmpType = type;
  //   this.TableDatas = Object.values(this.MainDatas.filter((e: any) => this.common.ToLowerCase(e.EmpType) == this.Filter.EmpType));
  //   this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
  //     dtInstance.destroy();
  //     this.dtTrigger.next(null);
  //   });
  //   this.TotalCount = this.TableDatas.length;
  // }

  async ARCheck(event: any, i: number, IsAll = false, IsAll2 = false) {
    if (IsAll) {
      const ischeck = (event.target as HTMLInputElement).checked;

      const checkboxes = document.getElementsByName('IsCheckAll') as NodeListOf<HTMLInputElement>;
      checkboxes.forEach(checkbox => {
        checkbox.checked = false;
      });
      (event.target as HTMLInputElement).checked = ischeck;

      try {
        const dt = await this.dtElement.dtInstance;
        const pageInfo = dt.page.info();
        const currentPage = pageInfo.page;
        const start = pageInfo.start;
        const end = pageInfo.end - 1;

        const updatedData = [...this.TableDatas];

        if (IsAll2) {
          updatedData.forEach(e => e.IsARCheck = ischeck);
        } else {
          updatedData.forEach(e => e.IsARCheck = false);
          for (let i = start; i <= end; i++) {
            if (updatedData[i]) {  // Safety check
              updatedData[i].IsARCheck = ischeck;
            }
          }
        }

        this.TableDatas = updatedData;

        setTimeout(() => {
          if (this.dtElement?.dtInstance) {
            this.dtElement.dtInstance.then((dtInstance: any) => {
              dtInstance.page(currentPage).draw('page');
            });
          }
        }, 50);
      } catch (e) {
        console.error('Error in ARCheck:', e);
      }
    } else {
      this.TableDatas[i].IsARCheck = event.target.checked;
    }
  }

  async ApprovalMatrixRequestProcess(SelectType: string) {
    if (this.TableDatas.filter((e: any) => e.IsARCheck).length > 0) {
      await this.common.getPageRights()
      if (this.common.PageRight.IsView) {
        if ((SelectType == 'Reject' && this.Filter.Remark != '' && this.Filter.Remark != null) || SelectType == 'Approve') {
          const modalRef = this.modalService.open(ConfirmationComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = 'Do you want to ' + SelectType + '?';
          modalRef.result.then(async (result: any) => {
            if (result) {
              this.isDisabled = true;
              const length = this.TableDatas.filter((e: any) => e.IsARCheck).length;
              let index = 0;
              //await this.TableDatas.filter((e: any) => e.IsARCheck).forEach(async (element: any) => {
              //await this.approvalMatrix.ApprovalMatrixRequestProcess({ SelectType: SelectType, WebESSApprovalRequestTrackingId: element.WebESSApprovalRequestTrackingId, Remark: this.Filter.Remark, approvedid: element.EmpMasterId, EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
              await this.approvalMatrix.ApprovalMatrixRequestProcess({ SelectType: SelectType, WebESSApprovalRequestTrackingId: this.TableDatas.filter((e: any) => e.IsARCheck).map((e: any) => e.WebESSApprovalRequestTrackingId).toString(), Remark: this.Filter.Remark, EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
                next: (response) => {
                  //index += 1;
                  if (response.Error_Code == '49' || response.Error_Code == '50' || response.Error_Code == '51') {
                    //this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
                    const modalRef = this.modalService.open(AlertSuccessComponent, {
                      size: 'md',
                      backdrop: 'static',
                      centered: true,
                      windowClass: 'confirmation-modal'
                    });
                    modalRef.componentInstance.Message = response.Error_Message;
                    modalRef.result.then((result: any) => {
                      if (result) {
                        this.ApprovalMatrixRequest()
                      }
                    });
                  } else {
                    this.toast.show({ message: response.Error_Message, type: toastTypeEnum.danger });
                  }
                  // if (index == length) {
                  this.isDisabled = false;
                  //   this.ApprovalMatrixRequest();
                  //   //location.reload();
                  //   this.toast.show({ message: 'Selected entry ' + SelectType, type: toastTypeEnum.success });
                  // }
                },
                complete: () => { },
                error: (error) => {
                  this.isDisabled = false;
                },
              });
              //});
            }
          }).catch(() => { });
        } else {
          this.toast.show({ message: 'Please enter remark', type: toastTypeEnum.warning });
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.warning });
      }
    } else {
      this.toast.show({ message: 'Kindly select atleast one request', type: toastTypeEnum.warning });
    }
  }

  ClearData() {
    this.MainDatas = [];
    this.TableDatas = [];
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }
}
